// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"334":"90e2fb989d323aa1","813":"8a2a463060dbba6f"}[chunkId] + ".js";
};